import CatalogPage from 'pages/CatalogPage/DH/CatalogPage';

export default CatalogPage;
